import React from 'react';
import { get, includes, replace } from 'lodash';
import { string } from 'prop-types';
import { FlexContainer, Button, HasPermissions } from '../../common';

const DownloadInvoice = ({ url, origin, ...props }) => {
    const status = get(props, 'assignInfo.status.code', '1');
    const validStatuses = ['5', '50', '51', '53', '54', '55', '56', '57', '58', '59', '60'];
    const disabled = url.search('http') === -1;
    if (!includes(validStatuses, status)) return null;
    return (
        <HasPermissions to={['order-detail-page:download-invoice']}>
            <FlexContainer flex='1' justify='center' align='flex-end'>
                <FlexContainer>
                    <Button
                        link
                        text={disabled ? 'Pendiente boleta (Paperless)' : 'Imprimir boleta'}
                        disabled={disabled}
                        onClick={() => window.open(replace(url, 'down=true', ''))}
                        className='sisaButton'
                    />
                </FlexContainer>
            </FlexContainer>
        </HasPermissions>
    );
};

DownloadInvoice.propTypes = {
    url: string,
    origin: string
};

export default DownloadInvoice;
